import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  inject,
  Input,
  OnInit,
  Output,
  Renderer2,
  signal,
  ViewEncapsulation,
} from '@angular/core';
import {IControlDataChanged, TableControlService} from 'frontier/nucleus';
import {ITableVerticalDataRow} from '../../table-vertical-api-adapter';
import {EMPTY, Observable, of} from 'rxjs';
import {AbstractControl, FormControl, ValidatorFn} from '@angular/forms';
import {catchError, finalize, tap} from "rxjs/operators";
import {ICellChangedEvent} from '../cell-changed-event.interface';

@Component({
  selector: 'kpi4me-base-cell-editor',
  templateUrl: './base-cell-editor.component.html',
  styleUrls: ['./base-cell-editor.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: true,
})
export class BaseCellEditorComponent implements OnInit {
  protected _tableControlService = inject(TableControlService);
  protected initialValue: any;

  protected _row: ITableVerticalDataRow;

  formControl: FormControl;

  invalidMessageValidator: ValidatorFn;
  @Input() hideLabel: boolean;
  @Output() cellChanged = new EventEmitter<ICellChangedEvent>();
  @Output() updateTable = new EventEmitter();
  @Output() selectionDataChanged = new EventEmitter<IControlDataChanged>();
  @Output() updateRepositories = new EventEmitter();
  @Output() changeComplete = new EventEmitter();
  error = signal(null);

  set row(r: ITableVerticalDataRow) {

    this.initialValue = r.value;

    this._row = r;

    this.invalidMessageValidator = (control: AbstractControl) => {
      return r.invalidMessage && (control.value === null || control.value === '') ?
        {invalidMessage: r.invalidMessage} : null;
    };

    this.formControl = new FormControl(r.value, [this.invalidMessageValidator]);
    this.formControl.markAllAsTouched();

  }

  updateRow(r: ITableVerticalDataRow) {
    if (this.formControl.dirty) {
      return
    }
    this.initialValue = r.value;
    this._row = r;
    this.formControl.removeValidators(this.invalidMessageValidator)
    this.invalidMessageValidator = (control: AbstractControl) => {
      return r.invalidMessage && (control.value === null || control.value === '') ?
        {invalidMessage: r.invalidMessage} : null;
    };
    this.formControl.addValidators(this.invalidMessageValidator)
    this.formControl.setValue(r.value);
    this.formControl.markAllAsTouched();

  }

  get row(): ITableVerticalDataRow {
    return this._row;
  }

  getValueForApi = () => {
    console.log(this.formControl.value);
    if (this.formControl.valid === false) {
      return this.initialValue;
    }
    return this.formControl.value;
  }

  constructor(
    protected renderer: Renderer2,
    protected element: ElementRef,
    protected cdr: ChangeDetectorRef,
  ) {
  }

  @HostListener('keydown.enter', ['$event']) onEnter(event: KeyboardEvent) {
    console.log('enter keydown');

    this.changeValue().subscribe((): void => {
      const cellEditorWrapper = this.renderer.parentNode(this.element.nativeElement);
      const cellRenderer = this.renderer.parentNode(cellEditorWrapper);
      const td = this.renderer.parentNode(cellRenderer);
      const tr = this.renderer.parentNode(td);
      const tbody = this.renderer.parentNode(tr);
      const nextRow: any = Array.from(tbody.rows).find((row: any): boolean => row.rowIndex === tr.rowIndex + 1);
      try {
        const inputOfNextRow = nextRow.children[1].children[0].children[0].children[0].children[0].children[0]
          .children[0].children[0].children[1].children[0];
        (<HTMLInputElement>inputOfNextRow).focus();
      } catch (e) {
        console.warn('Could not select next input element');
      }
    })
  }

  @HostListener('focusout', ['$event']) onBlur() {
    console.log('focusout');
    this.confirmChange();
  }


  ngOnInit(): void {
    return null;
  }

  changeValue(): Observable<any> {
    const currentValue = this.getValueForApi();
    if (currentValue == this.initialValue) {
      console.log('Value not changed');
      return EMPTY;
    }
    return this._tableControlService.tableControlChangeLine({
      InstanceId: this.row.apiInstance.instanceid,
      RowObject: this.row.apiRow.obj,
      RowIdx: this.row.apiRow.rowidx,
      Attribute: this.row.attribute,
      AttributeIndex: this.row.attributeIndex,
      Value: currentValue,
    }).pipe(tap(rowResponse => {
      this.error.set(null);
      // The value is saved — reset the dirty flag BEFORE cellChanged triggers the update
      // round, otherwise updateRow skips this (and every future) api update for the field.
      this.formControl.markAsPristine();
      this.cellChanged.emit({apiRow: rowResponse, verticalRow: this.row});
      this.updateRepositories.emit();
      this.initialValue = this.getValueForApi();
    }), catchError((err) => {
      // this.formControl.patchValue(this.initialValue);
      this.error.set(err.error?.error?.userMsg);
      this.initialValue = currentValue;
      return of(err)
    }))
  }

  confirmChange(): void {
    this.changeValue().pipe(
      finalize(() => this.changeComplete.emit())
    ).subscribe();
  }
}
